import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CaseService } from '../../services/case.service';
import { SharedHttpService } from './../../services/shared-http.service';

@Component({
  selector: 'app-commite-responses',
  templateUrl: './commite-responses.component.html',
  styleUrls: ['./commite-responses.component.scss']
})
export class CommiteResponsesComponent implements OnInit {

  @Input() eCaseId: any;
  @Input() loadDataFP: Observable<any>;

  commiteResponsessArr: any = [];

  public loadfromparent = new BehaviorSubject<any>('');
  commiteRes;
  caseId: any;
  isInsert: boolean=false;
  commiteDecsionId: any;
  caseDetials: any;
  previewObj: {};
  constructor(public caseService: CaseService,private sharedService: SharedHttpService) { }
  ngOnInit(): void {
    this.caseId = this.caseService.case.caseId; 
    this.caseDetials = this.caseService.case;
    this.loadDataFP.subscribe((data) => {
      setTimeout(() => {
        this.loadData();
      }, 100);
    });
  }
  loadData() {
    this.sharedService.get(`api/Case/GetCommitteeDecsions?ecaseId=${this.eCaseId}`).subscribe(res => {
      this.commiteResponsessArr = res;
    })

  }

  CreateCommitteeDecsions(modal) {
    this.commiteDecsionId = null;
    this.loadfromparent.next({ "id": 0, "IsReadOnly": false }); 
    this.sharedService.openXLarge(modal);
    this.isInsert = true;
  }

  OnCreateCommitteeDecsions() {
    let obj = {
      "caseId": this.caseId,
      // "committeeId": 0,
      // "decsionTypeId": 0,
      "details": this.commiteRes,
      // "createdBy": 0,
      // "createdOn": "2023-01-12T10:39:05.522Z"
    };
    this.sharedService.post(`api/Case/AddCommitteeDecsion`, obj).subscribe(res => {
       this.commiteDecsionId = res.committeeDecsionId;
      this.loadfromparent.next({ "id": this.commiteDecsionId, "IsReadOnly": false });
      this.sharedService.showSuccessKey("CreatedSuccessfully");
      this.isInsert = false;
      this.loadData();
    
    });
  }

  AddAttachmentModal(modal, id, IsReadOnly) {
    this.loadfromparent.next({ "id": id, "IsReadOnly": false }); 
    this.sharedService.openXLarge(modal);
  }
  deletecommite(modal,commiteDecsionId:any) {
    this.sharedService.openSmall(modal);
    this.commiteDecsionId = commiteDecsionId;
}
deleteCommite(modal,commiteDecisionId:any) {
  this.sharedService.openSmall(modal);
  this.commiteDecsionId = commiteDecisionId;
}
onDelete(modal) {
    this.sharedService.get(`api/Case/DeleteCommitteeDecsion?CommitteeDecsionId=${this.commiteDecsionId}`).subscribe(res => {
        if (res == true) {
            this.loadData();
            this.sharedService.showSuccessKey("DeletedSuccessfully");
            modal.dismiss('Cross click');
        }
    });
}

 
}
